import { css } from '@emotion/css';
import { BaseStyle, BorderRadius, Color, Font, FontWeight } from 'src/styles';

export const paymentCollapse = css`
  ${BorderRadius.xxs}
  ${BaseStyle.clip}
`;

export const title = css`
  ${Font.h6}
  ${FontWeight.bold}
`;

export const subtitle = css`
  ${Font.md}
  color: ${Color.Gray7};
`;

export const paymentPanel = css`
  .ant-collapse-header {
    background-color: ${Color.Gray1};
    ${Font.md}
  }

  .ant-collapse-header-text {
    width: 100%;
  }

  .ant-collapse-content {
    background-color: ${Color.Gray2};
  }
`;
